import type { PartialMessages } from "../messages";

export const de: PartialMessages = {
  "status.syncing": "Synchron",
  "status.connecting": "Verbinden",
  "status.full": "Voll",
  "status.closed": "Getrennt",
  "toast.connecting": "Verbinden…",
  "toast.reconnecting": "Verbindung getrennt. Neuer Versuch…",
  "toast.retrying": "Wird gleich erneut versucht.",
  "toast.busy": "Gerade stark ausgelastet",
  "notice.mapChanged": "{name} hat die Karte gewechselt",

  "hint.place": "Klicken zum Setzen, ziehen für die Richtung (Esc bricht ab)",

  "kind.objective": "Ziel",
  "kind.rally": "Sammeln",
  "kind.enemy": "Feind",
  "kind.loot": "Loot",
  "kind.extract": "Extrakt",
  "kind.danger": "Gefahr",
  "kind.self": "Ich",
  "kind.ping": "Hier!",
  "hint.objective": "Wohin es geht",
  "hint.rally": "Treffpunkt",
  "hint.enemy": "In die Richtung setzen, aus der du ihn gesehen hast",
  "hint.loot": "Seltene Container, Leichen",
  "hint.extract": "Der geplante Ausgang",
  "hint.danger": "Minen, Sniper, offenes Gelände",
  "hint.self": "Deine Position. Neu setzen entfernt die alte",
  "hint.ping": "Marker, der nach 25 Sekunden verschwindet",

  "tool.clearMine": "Meine löschen",
  "tool.clearMineHint": "Entfernt alle Pins, die du gesetzt hast",

  "sidebar.map": "Karte (für alle)",
  "sidebar.styleSvg": "Illustriert",
  "sidebar.styleTile": "Satellit",
  "sidebar.floors": "Etage (nur deine Ansicht)",
  "sidebar.groundFloor": "Erdgeschoss",
  "sidebar.floorNote": "Pins auf anderen Etagen werden blasser dargestellt.",
  "sidebar.members": "{count} dabei",
  "sidebar.you": "du",
  "sidebar.guest": "Gast",
  "sidebar.clearAll": "Alle Pins löschen",
  "sidebar.openWindow": "In eigenem Fenster öffnen (nur ich)",
  "sidebar.invite": "Jemanden einladen",
  "sidebar.help": "Anleitung",
  "sidebar.feedback": "Rückmeldung senden",
  "sidebar.mapData": "Kartendaten",
  "sidebar.license": "Lizenz",
  "sidebar.licenseNote": "nur nicht-kommerzielle Nutzung",
  "sidebar.room": "Raum",

  "pin.facing": "Richtung",
  "pin.floor": "Etage",
  "pin.map": "Karte",
  "pin.noFacing": "Keine Richtung",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Notiz hinzufügen (z. B. Fenster im 3. Stock)",
  "pin.removeMine": "Diesen Pin löschen",
  "pin.removeOther": "Fremden Pin löschen",
  "pin.close": "Schließen",
  "compass.n": "N", "compass.ne": "NO", "compass.e": "O", "compass.se": "SO",
  "compass.s": "S", "compass.sw": "SW", "compass.w": "W", "compass.nw": "NW",

  "handoff.title": "In eigenem Fenster öffnen",
  "handoff.lede":
    "Ein Link für dich selbst. Öffnet denselben Raum im Browser, damit Discord den Stream zeigen kann, während die Karte auf einem anderen Bildschirm liegt.",
  "handoff.open": "Im Browser dieses Rechners öffnen",
  "handoff.or": "Auf einem anderen Gerät",
  "handoff.codeHint": "Rufe dort {host}/j/ auf und gib den Code oben ein.",
  "handoff.copy": "Link kopieren",
  "handoff.copied": "Kopiert",
  "handoff.copyFailed": "Oben markiert — drücke Strg+C",
  "handoff.expiry": "Der Link funktioniert einmal. Er läuft in {time} ab.",
  "handoff.warn":
    "Nicht weitergeben: Beim Öffnen ist er verbraucht. Nutze dafür „Jemanden einladen“.",
  "handoff.creating": "Link wird erstellt…",
  "handoff.failed": "Link konnte nicht erstellt werden",

  "invite.title": "Jemanden einladen",
  "invite.lede":
    "Hol jemanden dazu, der nicht im Sprachkanal ist. Er gibt einen Namen ein und kann Pins setzen.",
  "invite.copy": "Link kopieren",
  "invite.warn": "Jeder mit diesem Link kann beitreten. Nicht öffentlich posten.",
  "invite.budget": "Noch {left} Personen, läuft in {time} ab (genutzt {used}/{max}).",
  "invite.revoke": "Diesen Link sofort sperren",
  "invite.revoked": "Link gesperrt.",
  "invite.creating": "Link wird erstellt…",
  "invite.failed": "Link konnte nicht erstellt werden",
  "invite.revokeFailed": "Sperren fehlgeschlagen",

  "join.title": "Der Karte beitreten",
  "join.lede":
    "Du wurdest zu einer Raid-Karte eingeladen. Wähle einen Anzeigenamen. Deine Pins tragen ihn.",
  "join.name": "Name",
  "join.go": "Beitreten",
  "join.joining": "Beitreten…",
  "join.failed": "Beitritt fehlgeschlagen",

  "feedback.title": "An den Autor senden",
  "feedback.request": "Wunsch",
  "feedback.bug": "Fehler",
  "feedback.other": "Sonstiges",
  "feedback.requestHint": "Schön wäre…",
  "feedback.bugHint": "Etwas stimmt nicht",
  "feedback.otherHint": "Alles andere",
  "feedback.placeholder":
    "z. B. Ich möchte Linien ziehen, nicht nur Pfeile / Etagen wechseln auf Streets nicht",
  "feedback.note":
    "Dein Discord-Anzeigename und deine ID werden mitgesendet, damit wir antworten können.",
  "feedback.send": "Senden",
  "feedback.sending": "Wird gesendet…",
  "feedback.sent": "Gesendet. Danke!",
  "feedback.failed": "Senden fehlgeschlagen",

  "time.minutes": "{n} Min.",
  "time.hoursMinutes": "{h} Std. {m} Min.",

  "error.roomFull": "Dieser Raum ist voll",
  "error.tooManyWindows": "Zu viele Fenster für diesen Raum. Schließe eines.",
  "error.serverFull": "Der Server ist voll",
  "error.session": "Deine Sitzung ist ungültig. Bitte neu öffnen.",
  "error.handoffSpent":
    "Dieser Link funktioniert nicht. Er ist ein Einmal-Link für seinen Ersteller. Um jemanden dazuzuholen, erstelle auf der Karte einen Einladungslink.",
  "error.inviteSpent": "Dieser Einladungslink ist nicht mehr gültig. Bitte um einen neuen.",
  "error.inviteNotOwner": "Nur wer den Link erstellt hat, kann ihn sperren",
  "error.noRoom": "Kein Raum angegeben",
  "error.needName": "Bitte gib einen Namen ein",
  "error.tooShort": "Bitte schreibe etwas mehr",
  "error.tooLong": "Das ist zu lang",
  "error.badKind": "Ungültige Kategorie",
  "error.rateLimited": "Zu viele Nachrichten. Bitte warte etwa 10 Minuten.",
  "error.busy": "Gerade ausgelastet. Bitte gleich erneut versuchen.",
  "error.sendFailed": "Senden fehlgeschlagen. Bitte später erneut versuchen.",
  "error.feedbackClosed": "Rückmeldungen sind derzeit geschlossen",
  "error.sessionGone": "Die ursprüngliche Sitzung ist beendet. Öffne die Aktivität erneut.",

  "landing.tagline1": "Teile eine Tarkov-Karte",
  "landing.tagline2": "mit allen im Discord-Call und erklärt sie gemeinsam.",
  "landing.install": "Zu Discord hinzufügen",
  "landing.installNote": "Kostenlos. Start über das Raketensymbol im Sprachkanal.",
  "landing.body":
    "Alle im Call sehen dieselbe Karte. Klicken setzt einen Pin; ziehst du dabei, kommt ein Richtungspfeil dazu — so zeigst du nicht nur wo, sondern auch wohin.",
  "landing.point1": "Im selben Call zu sein genügt. Keine Codes eintippen",
  "landing.point2": "Alle 13 Karten. Illustriert oder Satellit, dazu Etagen",
  "landing.point3": "Pins bleiben liegen und lassen sich später nachschlagen",
  "landing.point4": "Wer nicht im Call ist, kommt über einen Einladungslink dazu",
  "landing.footNote":
    "Das Spiel wird nie angefasst. Keine Dateien, kein Speicher, nichts über dem Spiel gezeichnet. Jeder Pin wird von Hand gesetzt.",
  "landing.footCredit":
    "Ein Hobbyprojekt, kostenlos betrieben. Kartendaten von {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov ist ein Produkt von Battlestate Games Limited; dies ist ein inoffizielles Fanprojekt ohne Verbindung dorthin.",
  "landing.updates": "Neuigkeiten",
  "landing.allUpdates": "Alle Neuigkeiten",

  "boot.connecting": "Verbindung zu Discord…",
  "boot.failedTitle": "Start fehlgeschlagen",
};
